/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WebsiteCatalogSort {
    RELEVANCE = 'relevance',
    PRICE_ASC = 'price-asc',
    PRICE_DESC = 'price-desc',
    UPDATED_DESC = 'updated-desc',
}
